import React, { FC } from 'react';
import Modal from 'components/shared/Modal';
import Form from 'app/modules/posts/modules/detail/modules/audienceRestrictions/components/Form';
import { AudienceRestrictions } from 'app/modules/posts/types/AudienceRestrictionsOptions';
import { useTranslation } from 'react-i18next';

type Props = {
  isShown: boolean;
  onClose: () => void;
  onSubmit: (value: AudienceRestrictions) => void;
  initialValue: AudienceRestrictions | null;
  page: {
    id: number;
    type: number;
  };
};

const AudienceRestrictionsModal: FC<Props> = ({
  isShown,
  onSubmit,
  onClose,
  initialValue,
  page,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={isShown} onClose={onClose}>
      <Modal.Header title={t('audienceRestrictions.modalTitle')} />
      <Form
        page={page}
        onClose={onClose}
        onSubmit={onSubmit}
        initialValue={initialValue}
      />
    </Modal>
  );
};

export default AudienceRestrictionsModal;
